import * as storageService from "./storage"

const storageKeys = storageService.getStorageKeys()
const homeIntroDismissed = storageKeys.HOME_INTRO_DISMISSED
const onboardingSurveyDismissed = storageKeys.ONBOARDING_SURVEY_DISMISSED

const isIntroAvailable = ({ treatmentPlan }) => {
  if (treatmentPlan) {
    return false
  }

  if (isIntroDismissed()) {
    return false
  }

  return true
}

const isIntroDismissed = () =>
  !!storageService.getItem({ id: homeIntroDismissed })

const dismissIntro = () =>
  storageService.setItem({
    id: homeIntroDismissed,
    data: true,
  })

const cleanupStorage = () => {
  storageService.removeItem({ id: homeIntroDismissed })
  storageService.removeItem({
    id: onboardingSurveyDismissed,
    storageType: storageService.getStorageTypes().SESSION,
  })
}

export { isIntroAvailable, isIntroDismissed, dismissIntro, cleanupStorage }
